<div *ngIf="screenWidth >= FOOTER_EXTENDED_MIN_WIDTH">
	<div class="flex justify-content-around flex-wrap max-w-screen">
		<div class="grid col-12 align-items-center justify-content-center text-sm p-0 py-1 surface-ground">
			<div class="col-6 flex align-items-center justify-content-start py-2">
				<p-button styleClass="p-button-footer-privacy text-sm" (onClick)="changeLanguage()">
					<ng-template pTemplate="content">
						<div class="flex flex-row gap-3 align-items-center">
							<img alt="{{ getCurrentLanguageName() }}" [src]="getCurrentLanguageFlag()" class="w-2rem">
							<div [class]="getMenuTheme() === 'dim' ? 'text-300' : 'text-0'">{{ getCurrentLanguageName() }}
							</div>
						</div>
					</ng-template>
				</p-button>
				<div [class]="getMenuTheme() === 'dim' ? 'text-300' : 'text-0'">|</div>
				<p-button [styleClass]="getPrivacyButtonStyleClass()" label="{{ 'FOOTER_TERMS' | translate }}"
					(onClick)="openNewTab('/privacy/terms')"></p-button>
				<div [class]="getMenuTheme() === 'dim' ? 'text-300' : 'text-0'">|</div>
				<p-button [styleClass]="getPrivacyButtonStyleClass()" label="{{ 'FOOTER_PRIVACY' | translate }}"
					(onClick)="openNewTab('/privacy/policy')"></p-button>
				<div [class]="getMenuTheme() === 'dim' ? 'text-300' : 'text-0'">|</div>
				<p-button [styleClass]="getPrivacyButtonStyleClass()" label="{{ 'FOOTER_COOKIES' | translate }}"
					(onClick)="openNewTab('/privacy/cookies')"></p-button>
				<div [class]="getMenuTheme() === 'dim' ? 'text-300' : 'text-0'">|</div>
				<p-button [styleClass]="getPrivacyButtonStyleClass()" label="{{ 'FOOTER_CONTACT_US' | translate }}"
					(onClick)="openNewTabContactUs()"></p-button>
			</div>
			<div class="col-6 flex align-items-center justify-content-end py-2">
				<label class="text-sm"
					[class]="getMenuTheme() === 'dim' ? 'text-300' : 'text-0'">{{copyrightInfo()}}</label>
			</div>
		</div>
	</div>
</div>
<div *ngIf="screenWidth < FOOTER_EXTENDED_MIN_WIDTH">
	<div class="flex justify-content-around flex-wrap max-w-screen">
		<div class="grid col-12 align-items-center justify-content-center text-sm surface-ground">
			<div class="col-12 flex justify-content-center py-0">
				<p-button styleClass="p-button-footer-privacy text-sm" (onClick)="changeLanguage()">
					<ng-template pTemplate="content">
						<div class="flex flex-row gap-3 align-items-center">
							<img alt="{{ getCurrentLanguageName() }}" [src]="getCurrentLanguageFlag()" class="w-2rem">
							<div [class]="getMenuTheme() === 'dim' ? 'text-300' : 'text-0'">{{ getCurrentLanguageName() }}
							</div>
						</div>
					</ng-template>
				</p-button>
			</div>
			<div *ngIf="!onExtendedMobile()" class="col-12 flex justify-content-center py-1">
				<p-button [styleClass]="getPrivacyButtonStyleClass() + ' underline'"
					label="{{ 'FOOTER_TERMS' | translate }}" (onClick)="openNewTab('/privacy/terms')"></p-button>
				<p-button [styleClass]="getPrivacyButtonStyleClass() + ' underline'"
					label="{{ 'FOOTER_PRIVACY' | translate }}" (onClick)="openNewTab('/privacy/policy')"></p-button>
				<p-button [styleClass]="getPrivacyButtonStyleClass() + ' underline'"
					label="{{ 'FOOTER_COOKIES' | translate }}" (onClick)="openNewTab('/privacy/cookies')"></p-button>
				<p-button [styleClass]="getPrivacyButtonStyleClass() + ' underline'"
					label="{{ 'FOOTER_CONTACT_US' | translate }}" (onClick)="openNewTabContactUs()"></p-button>
			</div>
			<div *ngIf="onExtendedMobile()" class="grid mt-0">
				<div class="col-12 flex justify-content-center py-0">
					<p-button [styleClass]="getPrivacyButtonStyleClass() + ' underline'"
						label="{{ 'FOOTER_TERMS' | translate }}" (onClick)="openNewTab('/privacy/terms')"></p-button>
				</div>
				<div class="col-12 flex justify-content-center py-0">
					<p-button [styleClass]="getPrivacyButtonStyleClass() + ' underline'"
						label="{{ 'FOOTER_PRIVACY' | translate }}" (onClick)="openNewTab('/privacy/policy')"></p-button>
				</div>
				<div class="col-12 flex justify-content-center py-0">
					<p-button [styleClass]="getPrivacyButtonStyleClass() + ' underline'"
						label="{{ 'FOOTER_COOKIES' | translate }}" (onClick)="openNewTab('/privacy/cookies')"></p-button>
				</div>
				<div class="col-12 flex justify-content-center py-0">
					<p-button [styleClass]="getPrivacyButtonStyleClass() + ' underline'"
						label="{{ 'FOOTER_CONTACT_US' | translate }}" (onClick)="openNewTabContactUs()"></p-button>
				</div>
			</div>
			<div class="col-12 flex justify-content-center text-center py-2">
				<label class="text-sm" [class]="getMenuTheme() === 'dim' ? 'text-300' : 'text-0'">{{ copyrightInfo()
					}}</label>
			</div>
		</div>
	</div>
</div>